// apiService.js
export function getApiUrl() {
    const host = window.location.hostname;

    if (host === "localhost") {
        return "http://localhost:5000"; // Pro vývojové prostředí
    } else {
        console.log("Produkcni URL je použita");
        return "https://maugliherna.geogrep.cz"; // Pro produkční prostředí
    }
}

export async function apiFetch(endpoint, options = {}) {
    const API_URL = getApiUrl();
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('userToken')}`,
        ...options.headers,
    };

    console.log(`Fetching: ${API_URL}${endpoint} with options:`, options);

    
    try {
        const response = await fetch(`${API_URL}${endpoint}`, { ...options, headers });

        if (response.status === 401 || response.status === 403) {
            // Token je neplatný nebo expiroval, odhlásit uživatele
            localStorage.removeItem('userToken'); // Odstranit token z localStorage
            window.location.href = '/login'; // Přesměrovat uživatele na přihlašovací stránku
            return; // Ukončit vykonávání funkce
        }

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message || 'Došlo k chybě na serveru');
        }
        return data;
    } catch (error) {
        console.error("Chyba při volání API:", error);
        throw error; // Vrátit chybu pro další zpracování
    }
}